import { render, staticRenderFns } from "./Fifth_mobile.vue?vue&type=template&id=2244c74a&"
import script from "./Fifth_mobile.vue?vue&type=script&lang=js&"
export * from "./Fifth_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Fifth_mobile.vue?vue&type=style&index=0&id=2244c74a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports